import { FC } from 'react';
import {
  TextBody,
  Spacer,
  Stack,
  BlockList,
  Input,
  Icon,
  Tooltip,
} from '@pypestream/design-system';
import { useFormContext } from 'react-hook-form';
import { TranslationComponent, useTranslation } from '@pypestream/translations';

export const TabSupervisor: FC<{ viewOnly?: boolean }> = ({ viewOnly }) => {
  const { register } = useFormContext();
  const { t } = useTranslation();

  return (
    <>
      <BlockList>
        <div>
          <Stack alignItems="center" gutter="2xsmall">
            <TextBody size="small">
              <TranslationComponent i18nKey="pro-studio/workflows:vocabulary.supervisor_solution_name">
                Solution Name
              </TranslationComponent>
            </TextBody>
            <Tooltip
              placement="right"
              // In i18n like the label above it: the Agent vocabulary overlay
              // can only rewrite strings that live in a bundle, so leaving this
              // hardcoded made the tooltip say "solution" twice under a label
              // the flag had already renamed to "Agent Name".
              content={
                t(
                  'pro-studio/workflows:vocabulary.supervisor_solution_name_tooltip'
                ) || ''
              }
            >
              <Icon name="info" color="gray" size="xsmall" />
            </Tooltip>
          </Stack>
          <Spacer size="2xsmall" />
          <Input
            test-id="ps-agents-supervisor-name-input"
            variant="outlined"
            placeholder="John Doe"
            {...register('supervisorName')}
            disabled={viewOnly}
          />
        </div>
        {/* <div>
          <Stack alignItems="center" gutter="2xsmall">
            <TextBody size="small">Other Information</TextBody>
            <Tooltip
              placement="right"
              content="Any additional context or instructions for the model to guide how it behaves or responds in specific situations."
            >
              <Icon name="info" color="gray" size="xsmall" />
            </Tooltip>
          </Stack>
          <Spacer size="2xsmall" />
          <Textarea
            variant="outlined"
            placeholder="Other Information"
            rows={3}
            {...register('otherInformation')}
          />
        </div> */}
      </BlockList>
      <Spacer size="large" />
      {/* <Grid gutter="large" rowGutter="large">
        <GridCell xsmall="6">
          <Stack justifyContent="space-between" alignItems="center">
            <Stack alignItems="center" gutter="2xsmall">
              <TextBody size="small">Temperature</TextBody>
              <Tooltip
                placement="right"
                content="Controls the randomness of the model's responses. Higher values (e.g., 0.8) make it more creative; lower values (e.g., 0.2) make it more focused and predictable."
              >
                <Icon name="info" color="gray" size="xsmall" />
              </Tooltip>
            </Stack>
            <TextBody size="small">0.2</TextBody>
          </Stack>
          <Slider
            showMinMaxLabels={false}
            step={0.2}
            min={0}
            max={1}
            value={0.2}
          />
        </GridCell>
        <GridCell xsmall="6">
          <Stack justifyContent="space-between" alignItems="center">
            <Stack alignItems="center" gutter="2xsmall">
              <TextBody size="small">Max output tokens</TextBody>
              <Tooltip
                placement="right"
                content="Sets the maximum length of the model's responses. One token is roughly 3/4 of a word."
              >
                <Icon name="info" color="gray" size="xsmall" />
              </Tooltip>
            </Stack>
            <TextBody size="small">2048</TextBody>
          </Stack>
          <Slider
            showMinMaxLabels={false}
            step={1}
            min={0}
            max={5000}
            value={2048}
          />
        </GridCell>
        <GridCell xsmall="6">
          <Stack justifyContent="space-between" alignItems="center">
            <Stack alignItems="center" gutter="2xsmall">
              <TextBody size="small">Top P</TextBody>
              <Tooltip
                placement="right"
                content="Controls the diversity of responses by narrowing down the model's choices to the most likely ones. Lower values limit variation."
              >
                <Icon name="info" color="gray" size="xsmall" />
              </Tooltip>
            </Stack>
            <TextBody size="small">0.8</TextBody>
          </Stack>
          <Slider
            showMinMaxLabels={false}
            step={0.1}
            min={0}
            max={1}
            value={0.8}
          />
        </GridCell>
        <GridCell xsmall="6">
          <Stack justifyContent="space-between" alignItems="center">
            <Stack alignItems="center" gutter="2xsmall">
              <TextBody size="small">Top K</TextBody>
              <Tooltip
                placement="right"
                content="Limits the model to selecting from the top K most likely next words. Smaller values reduce randomness and increase focus."
              >
                <Icon name="info" color="gray" size="xsmall" />
              </Tooltip>
            </Stack>
            <TextBody size="small">0.2</TextBody>
          </Stack>
          <Slider
            showMinMaxLabels={false}
            step={0.1}
            min={0}
            max={1}
            value={0.2}
          />
        </GridCell>
      </Grid> */}
    </>
  );
};
